import { inject } from "vue";

export function reusablePaymentForm() {
  const store = inject("$store");
  const axios = inject("$axios");
  const generateReferenceNumber = () => {
    return Math.floor(100000000000 + Math.random() * 900000000000).toString();
  };

  const submitPlanDetails = (plan) => {
    store.commit("SET_PLAN_DETAILS", {
      referenceNumber: generateReferenceNumber(),
      planName: plan.name,
      premium: plan.price,
      amountPay: plan.price,
    });
  };

  const submitCheckout = async () => {
    try {
      const crypto_id = "6a4f2a146a60c2dd26d4b00b0sz74k8s60300";
      const payload = {
        external_id: `Reference Number: ${store.state.planDetails.referenceNumber}`,
        amount: store.state.planDetails.amountPay,
        description: "Renewal IWC Health Plan",
        invoice_duration: 86400,
        customer: {
          given_names: "Juan",
          surname: "Dela Cruz",
          email: "vergaraalvin17@gmail.com",
          mobile_number: "9274468935",
          addresses: [
            {
              city: "Manila",
              country: "Philippines",
            },
          ],
        },
        customer_notification_preference: {
          invoice_created: ["email"],
          invoice_paid: ["email"],
        },
        success_redirect_url: `https://iwcpay.dev-sandbox.me/payment/center/payment-confirmation/${crypto_id}`,
        failure_redirect_url: "https://www.google.com",
        currency: "PHP",
        items: [
          {
            name: store.state.planDetails.planName,
            quantity: 1,
            price: store.state.planDetails.amountPay,
            category: "Healthcard",
            url: "https://imsdeped.anec.global",
          },
        ],
        payment_methods: [
          "CREDIT_CARD",
          "DD_BPI",
          "DD_UBP",
          "DD_RCBC",
          "PAYMAYA",
          "GRABPAY",
          "GCASH",
          "BDO_ONLINE_BANKING",
          "BPI_ONLINE_BANKING",
          "UNIONBANK_ONILNE_BANKING",
          "BOC_ONLINE_BANKING",
          "CHINABANK_ONLINE_BANKING",
          "INSTAPAY_ONLINE_BANKING",
          "LANDBANK_ONLINE_BANKING",
          "MAYBANK_ONLINE_BANKING",
          "METROBANK_ONLINE_BANKING",
          "PNB_ONLINE_BANKING",
          "PSBANK_ONLINE_BANKING",
          "PESONET_ONLINE_BANKING",
          "RCBC_ONLINE_BANKING",
          "ROBINSONS_BANK_ONLINE_BANKING",
          "SECURITY_BANK_ONLINE_BANKING",
          "QRPH",
        ],
      };

      const response = await axios.post(
        "https://api.xendit.co/v2/invoices",
        payload,
        {
          headers: {
            Authorization: `Basic eG5kX2RldmVsb3BtZW50X2l6bjQwb2JlR2cxMENYSEk5RjA3ZzNQbU5uYzdpb1AxcmRuOFNQZVUzUzN1RUdYOXBvVngwbnlmeW9RYzo6`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log(response.data);

      store.commit("SET_PLAN_DETAILS", {
        xendit_id: response.data.id,
      });

      // Redirect to Xendit payment page
      window.location.href = response.data.invoice_url;
    } catch (error) {
      console.error(error.response?.data || error);
    }
  };
  const submitInstallmentCheckout = async () => {
    try {
      const crypto_id = "6a4f2a146a60c2dd26d4b00b0sz74k8s60300";
      const payload = {
        external_id: `Reference Number: ${store.state.planDetails.referenceNumber}`,
        amount: store.state.selectedInstallment.amountToPay,
        description: "Renewal IWC Health Plan",
        invoice_duration: 86400,
        customer: {
          given_names: "Juan",
          surname: "Dela Cruz",
          email: "vergaraalvin17@gmail.com",
          mobile_number: "9274468935",
          addresses: [
            {
              city: "Manila",
              country: "Philippines",
            },
          ],
        },
        customer_notification_preference: {
          invoice_created: ["email"],
          invoice_paid: ["email"],
        },
        success_redirect_url: `https://iwcpay.dev-sandbox.me/payment/center/payment-confirmation/${crypto_id}`,
        failure_redirect_url: "https://www.google.com",
        currency: "PHP",
        items: [
          {
            name: store.state.planDetails.planName,
            quantity: 1,
            price: store.state.selectedInstallment.amountToPay,
            category: "Healthcard",
            url: "https://imsdeped.anec.global",
          },
        ],
        payment_methods: [
          "CREDIT_CARD",
          "DD_BPI",
          "DD_UBP",
          "DD_RCBC",
          "PAYMAYA",
          "GRABPAY",
          "GCASH",
          "BDO_ONLINE_BANKING",
          "BPI_ONLINE_BANKING",
          "UNIONBANK_ONILNE_BANKING",
          "BOC_ONLINE_BANKING",
          "CHINABANK_ONLINE_BANKING",
          "INSTAPAY_ONLINE_BANKING",
          "LANDBANK_ONLINE_BANKING",
          "MAYBANK_ONLINE_BANKING",
          "METROBANK_ONLINE_BANKING",
          "PNB_ONLINE_BANKING",
          "PSBANK_ONLINE_BANKING",
          "PESONET_ONLINE_BANKING",
          "RCBC_ONLINE_BANKING",
          "ROBINSONS_BANK_ONLINE_BANKING",
          "SECURITY_BANK_ONLINE_BANKING",
          "QRPH",
        ],
      };

      const response = await axios.post(
        "https://api.xendit.co/v2/invoices",
        payload,
        {
          headers: {
            Authorization: `Basic eG5kX2RldmVsb3BtZW50X2l6bjQwb2JlR2cxMENYSEk5RjA3ZzNQbU5uYzdpb1AxcmRuOFNQZVUzUzN1RUdYOXBvVngwbnlmeW9RYzo6`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log(response.data);

      store.commit("SET_PLAN_DETAILS", {
        xendit_id: response.data.id,
      });

      // Redirect to Xendit payment page
      window.location.href = response.data.invoice_url;
    } catch (error) {
      console.error(error.response?.data || error);
    }
  };

  return {
    submitPlanDetails,
    submitCheckout,
    submitInstallmentCheckout,
  };
}
